enum FeatureFlags {
  legacyDashboard = 'LEGACY DASHBOARD',
  donationsv2 = 'DONATIONS V2',
  showNonProdSidebar = 'SHOW NON PROD SIDEBAR',
  historicalOffers = 'HISTORICAL OFFERS',
  marketplaceBidStrength = 'MARKETPLACE BID STRENGTH',
  virtualizedDataTable = 'VIRTUALIZED DATA TABLE',
  offerShift = 'OFFER SHIFT',
  buyerEmailReminder = 'BUYER EMAIL REMINDER',
  marketplace = 'MARKETPLACE STOREFRONT',
  marketplaceOrdersPage = 'MARKETPLACE AWARD EMAILS',
  sendLossEmails = 'SEND LOSS EMAILS',
  suggestedNegotiations = 'SUGGESTED NEGOTIATIONS',
  legacySuggestedNegotiations = 'LEGACY SUGGESTED NEGOTIATIONS',
  certifiedBuyers = 'CERTIFIED BUYERS DL',
  demoStaticReport = 'DEMO STATIC REPORT',
  landingPage = 'LANDING PAGE',
  reservePriceSettings = 'RESERVE PRICE SETTINGS',
  offerShiftRecalculation = 'OFFER SHIFT RECALCULATION',
  offerShiftOfferCompFilter = 'OFFER SHIFT FILTER IN OFFER COMP',
  reservePriceExceptions = 'RESERVE PRICE EXCEPTIONS',
  awardingOpportunitiesExport = 'AWARDING OPPORTUNITIES EXPORT',
  offerCompProgressiveLoad = 'OFFER COMP PROGRESSIVE LOAD',
  lowDesirabilityFlag = 'LOW DESIRABILITY FLAG',
}

export default FeatureFlags;
